<script lang="ts">
    import { Position } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>

<Card cardHeaderprops="pb-0" headerTitle={Position}>
    <div slot="contentbody">
        <pre class="helper-classes">
            {`.p-static {
            position: static;
            }
            .p-absolute {
            position: absolute;
            }
            .p-fixed {
            position: fixed;
            }
            .p-relative {
            position: relative;
            }
            .p-initial {
            position: initial;
            }
            .p-inherit {
            position: inherit;
            }`}
        </pre>
    </div>
</Card>
